export default __webpack_public_path__ + "static/media/Green0002.e0fbb201.png";